<div class="pickup-things" *ngIf="title || displayItems.length > 0">
  <h5 class="pickup-things--title" *ngIf="title">{{ title }}</h5>

  <div class="pickup-things--container">
    <ng-container *ngFor="let item of displayItems">
      <a
        *ngIf="item.actionLink && !isExternalUrl(item.actionLink)"
        [routerLink]="item.actionLink"
        class="pickup-things--item pickup-things--card"
        [style.background-color]="item.backgroundColor || '#ffffff'"
        [attr.aria-labelledby]="'pickup-title-' + item.id"
      >
        <ng-container *ngTemplateOutlet="pickupCardBody; context: { item: item }"></ng-container>
      </a>
      <a
        *ngIf="item.actionLink && isExternalUrl(item.actionLink)"
        [href]="item.actionLink"
        [attr.target]="opensInNewTab(item.actionLink) ? '_blank' : null"
        [attr.rel]="opensInNewTab(item.actionLink) ? 'noopener noreferrer' : null"
        class="pickup-things--item pickup-things--card"
        [style.background-color]="item.backgroundColor || '#ffffff'"
        [attr.aria-labelledby]="'pickup-title-' + item.id"
      >
        <ng-container *ngTemplateOutlet="pickupCardBody; context: { item: item }"></ng-container>
      </a>
      <div
        *ngIf="!item.actionLink"
        class="pickup-things--item pickup-things--card pickup-things--card--static"
        [style.background-color]="item.backgroundColor || '#ffffff'"
      >
        <ng-container *ngTemplateOutlet="pickupCardBody; context: { item: item }"></ng-container>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #pickupCardBody let-item="item">
  <div
    class="pickup-things--icon"
    *ngIf="item.icon || item.iconSrc"
    [style.background-color]="item.iconColor || '#f5f5f5'"
  >
    <img *ngIf="item.iconSrc" [src]="item.iconSrc" [alt]="''" />
    <svg
      *ngIf="!item.iconSrc && item.icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <g [innerHTML]="getSafeIcon(item.icon)"></g>
    </svg>
  </div>

  <div class="pickup-things--content-wrapper">
    <div class="pickup-things--content">
      <h3 class="pickup-things--item-title" [id]="'pickup-title-' + item.id" [title]="item.title">
        {{ item.title }}
      </h3>
      <p class="pickup-things--item-description" *ngIf="item.description" [title]="item.description">
        {{ item.description }}
      </p>
    </div>
  </div>

  <span *ngIf="item.actionLink" class="pickup-things--action-icon" aria-hidden="true">
    <img src="/icons/right-arrow-blue.svg" alt="" width="24" height="24" />
  </span>
</ng-template>
